import { factory, getResponseDefault } from '@repo-level/core-front';
import type { CurrencyCode } from 'helpers/currency';

export interface Jackpots {
  [currencyCode: string]: {
    [id: string]: number;
  };
}

// use default transformResponse
export const jackpots = factory(
  (r) => () =>
    r<Jackpots>('get', 'games/jackpots', undefined, {
      transformResponse: [getResponseDefault()],
    })
);

export interface TotalJackpots {
  [currencyCode: string]: number;
}

// use default transformResponse
export const totalJackpots = factory(
  (r) => () =>
    r<TotalJackpots>('get', 'games/total_jackpots', undefined, {
      transformResponse: [getResponseDefault()],
    })
);

export interface IExchangeRate {
  exchangeRate: number;
  fee: number;
  totalExchangeRate: number;
}

export type TCurrencyRates = Record<CurrencyCode, IExchangeRate>;

export interface IExchangeRates {
  crypto: Record<CurrencyCode, TCurrencyRates>;
  fiat: Record<CurrencyCode, TCurrencyRates>;
}

export const exchangeRates = factory(
  (r) => () => r<IExchangeRates>('get', '/info/exchange_rates')
);
